import {Route, Routes, Navigate} from 'react-router-dom';
import React from 'react';
import {Layout} from '../components/General/Layout';
import {FaHome, FaTools, FaRegSun, FaRegListAlt, FaRegFileImage, FaUser} from 'react-icons/fa';

import Reports from '../views/Reports/Reports';
import PrintReports from '../views/Reports/PrintReports';
import SurveyPrint from '../views/Reports/SurveyPrint';
import Home from '../views/Home';
import Maintenance from '../views/Maintenance/Maintenance';
import ClientMaintenance from '../views/Maintenance/ClientMaintenance';
import ArrangerMaintenance from '../views/Maintenance/ArrangerMaintenance';
import LocationMaintenance from '../views/Maintenance/LocationMaintenance';
import UserMaintenance from '../views/Maintenance/UserMaintenance';
import ExceptionMaintenance from '../views/Maintenance/ExceptionMaintenance';
import Settings from '../views/Settings';
import Login from '../views/Login/Login';
import ForgotPassword from '../views/Login/ForgotPassword';
import RequireAuth from './RequireAuth';
import Unauthorized from '../views/Unauthorized';
import {useLocation} from 'react-router-dom';
import Roles from '../constants/Roles';
import UserAddEdit from '../views/Users/UserAddEdit';
import ResetPassword from '../views/Login/ResetPassword';
import {ImportReport} from '../views/Surveys/ImportReport';
import Surveys from '../views/Surveys/Surveys';
import {ImportSpreadsheets} from '../views/Surveys/ImportSpreadsheets';
import MasterMaintenance from '../views/Maintenance/MasterMaintenance';
import {MasterRecordMaintenance} from '../views/Maintenance/MasterRecordMaintenance';
import ClientReports from '../views/Reports/ClientReports';
import SurveyReports from '../views/Reports/SurveyReports';
import AnalysisReportsFuneral from '../views/Reports/AnalysisReportsFuneral';
import AnalysisReportsCremation from '../views/Reports/AnalysisReportsCremation';
import AnalysisReportsPreNeed from '../views/Reports/AnalysisReportsPreNeed';
import OpportunityFinancialReports from '../views/Reports/OpportunityFinancialReports';
import BatchSearch from '../views/Reports/BatchSearch';
import RegionMaintenance from '../views/Maintenance/RegionMaintenance';
import SurveyLookup from '../views/Surveys/SurveyLookup';
// import PrintSurveys from '../views/Surveys/PrintSurveys';
// import MaintainSurveys from '../views/Surveys/MaintainSurveys';
import FuneralMaintenance from '../views/Surveys/Maintenance/FuneralMaintenance';
import CremationMaintenance from '../views/Surveys/Maintenance/CremationMaintenance';
import CemetaryMaintenance from '../views/Surveys/Maintenance/CemetaryMaintenance';
import MonumentMaintenance from '../views/Surveys/Maintenance/MonumentMaintenance';
import PreNeedMaintenance from '../views/Surveys/Maintenance/PreNeedMaintenance';
import PetCremationMaintenance from '../views/Surveys/Maintenance/PetCremationMaintenance';
import EventPlanningMaintenance from '../views/Surveys/Maintenance/EventPlanningMaintenance';
import {OppPlanMaintenance} from '../views/Maintenance/OppPlanMaintenance';
import DepartmentMaintenance from '../views/Maintenance/DepartmentMaintenance';
import BatchLookup from '../views/Surveys/BatchLookup';
import BatchPrint from '../views/Reports/BatchPrint';
import {ImportRevenueTracker} from '../views/Surveys/ImportRevenueTracker';
import SalesClientReports from '../views/Reports/SalesClientReports';
import ScottPrograms from '../views/ScottPrograms/ScottPrograms';
import AREntry2 from '../views/ScottPrograms/AREntry2';
import OppPlanBatchMaintenance from '../views/Surveys/OppPlanBatchMaintenance';
import SurveyExport from '../views/Surveys/SurveyExport';

/* Controls what route the pages are linked to along with what permissions can see what pages and menu options */
const Routing = () => {
  /* Group permissions */

  const adminPermission = [Roles.ADMIN];

  const dataEntry = [Roles.ADMIN, Roles.GRAYSTONE_DATA_ENTRY];

  const globalPermission = [Roles.ADMIN, Roles.GRAYSTONE_DATA_ENTRY, Roles.GRAYSTONE_SALES, Roles.CLIENT_PERSONNEL];

  const nonClientPermission = [Roles.ADMIN, Roles.GRAYSTONE_DATA_ENTRY, Roles.GRAYSTONE_SALES];

  const clientPermission = [Roles.CLIENT_PERSONNEL];
  /* This array is passed to the menus/header bar to show the icons and current name of the screen 
      allowedRoles determines if it shows in the menu bar or not depending on what the user role is

      Security for navigating to a page is handled by the RequireAuth component 

      ** To set a custom title for a given page, use the useTitle hook in components/general/layout.js
      ** an example of it's use is in the MasterRecordMaintenance page
  */
  const menuItems = [
    {icon: FaHome, title: 'Dashboard', screen: '/home', allowedRoles: nonClientPermission},
    {icon: FaTools, title: 'Maintenance', screen: '/maintenance', allowedRoles: nonClientPermission},
    {icon: FaRegListAlt, title: 'Surveys', screen: '/surveys', allowedRoles: dataEntry},
    {icon: FaRegFileImage, title: 'Reports', screen: '/reports', allowedRoles: globalPermission},
    {icon: FaUser, title: 'Scott Programs', screen: '/scott-programs', allowedRoles: adminPermission},
    {icon: FaRegSun, title: 'Settings', screen: '/settings'},
  ];

  const routesWithoutMenu = ['/login', '/unauthorized', '/forgot-password', '/User/ResetPassword', '/User/Unlock'];
  const pathname = useLocation().pathname;

  const MenuWrapper = ({children}: {children: React.ReactNode}) => {
    if (routesWithoutMenu.includes(pathname)) {
      return <>{children}</>;
    } else {
      return <Layout screens={menuItems}> {children} </Layout>;
    }
  };

  // ROUTES CAN ONLY BE DEFINED ONCE, ORDER OF THE ROUTE DECLARED HERE TAKES PRECEDENCE FOR ROLE PURPOSES
  return (
    <MenuWrapper>
      <Routes>
        {/* Admin only routes */}
        <Route element={<RequireAuth allowedRoles={adminPermission} />}>
          <Route path="/maintenance/department" element={<DepartmentMaintenance />} />
          <Route path="/maintenance/exception" element={<ExceptionMaintenance />} />
          <Route path="/maintenance/exception/edit" element={<MasterRecordMaintenance />}>
            <Route path=":smasterId" element={<MasterRecordMaintenance />} />
          </Route>
          <Route path="/maintenance/spreadsheets" element={<ImportSpreadsheets />} />
          <Route path="/maintenance/revenuespreadsheets" element={<ImportRevenueTracker />} />
          <Route path="/maintenance/oppplanbatch" element={<OppPlanBatchMaintenance />} />
          <Route path="/maintenance/regions" element={<RegionMaintenance />} />
          <Route path="/maintenance/users" element={<UserMaintenance />} />
          <Route path="/reports/salesclient" element={<SalesClientReports />} />
          <Route path="/maintenance/users/add-edit" element={<UserAddEdit />}>
            <Route path=":userId" element={<UserAddEdit />} />
          </Route>

          <Route path="/scott-programs" element={<ScottPrograms />} />
          <Route path="/scott-programs/ar-entry-2" element={<AREntry2 />} />
        </Route>
        {/* Data entry and above routes */}
        <Route element={<RequireAuth allowedRoles={dataEntry} />}>
          <Route path="/surveys" element={<Surveys />} />
          {/* <Route exact path="/surveys/maintain" element={<MaintainSurveys />} /> */}
          <Route path="/surveys/lookup" element={<SurveyLookup />} />
          <Route path="/surveys/print" element={<SurveyPrint />} />
          <Route path="/surveys/export" element={<SurveyExport />} />
          <Route path="/surveys/funeral" element={<FuneralMaintenance />} />
          <Route path="/surveys/cremation" element={<CremationMaintenance />} />
          <Route path="/surveys/cemetery" element={<CemetaryMaintenance />} />
          <Route path="/surveys/monument" element={<MonumentMaintenance />} />
          <Route path="/surveys/preneed" element={<PreNeedMaintenance />} />
          <Route path="/surveys/pet-cremation" element={<PetCremationMaintenance />} />
          <Route path="/surveys/event-planning" element={<EventPlanningMaintenance />} />
          <Route path="/surveys/batch" element={<BatchLookup />} />

          <Route path="/reports/batch" element={<BatchSearch />} />
          <Route path="/reports/batch/edit" element={<BatchSearch />}>
            <Route path=":batchId" element={<BatchSearch />} />
          </Route>
        </Route>

        {/* Everyone has permission to these pages except clients */}
        <Route element={<RequireAuth allowedRoles={nonClientPermission} />}>
          {/* Routes available to all users */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />

          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/maintenance/clients" element={<ClientMaintenance />} />
          <Route path="/maintenance/arrangers" element={<ArrangerMaintenance />} />
          <Route path="/maintenance/locations" element={<LocationMaintenance />} />
          <Route path="/maintenance/master" element={<MasterMaintenance />} />
          <Route path="/maintenance/master/edit" element={<MasterRecordMaintenance />}>
            <Route path=":smasterId" element={<MasterRecordMaintenance />} />
          </Route>
          <Route path="/maintenance/opportunity-plan" element={<OppPlanMaintenance />} />

          <Route path="/reports/batch" element={<BatchSearch />} />
          <Route path="/reports/analysis/funeral" element={<AnalysisReportsFuneral />} />
          <Route path="/reports/analysis/cremation" element={<AnalysisReportsCremation />} />
          <Route path="/reports/analysis/preneed" element={<AnalysisReportsPreNeed />} />
          <Route path="/reports/import" element={<ImportReport />} />
          {/* <Route exact path="/reports/SurveyPrint" element={<SurveyPrint />} /> */}
          <Route path="/reports/viewer" element={<PrintReports />} />
          <Route path="/reports/survey" element={<SurveyReports />} />
          <Route path="/reports/opportunity" element={<OpportunityFinancialReports />} />
          <Route path="/reports/BatchPrint" element={<BatchPrint />} />
        </Route>

        {/* Everyone can see these */}
        <Route element={<RequireAuth allowedRoles={globalPermission} />}>
          <Route path="/reports" element={<Reports />} />
          <Route path="/settings" element={<Settings />} />
        </Route>

        {/* Client only routes */}
        <Route element={<RequireAuth allowedRoles={clientPermission} />}>
          <Route path="/reports/client" element={<ClientReports />} />
        </Route>

        {/* these have no authorization, add route to the routesWithoutMenu array to get them to not have a menu*/}
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/User/ResetPassword" element={<ResetPassword />} />
        <Route path="/User/Unlock" element={<ResetPassword unlock />} />

        {/* default route if none match, the requireAuth will send them to login if not logged in, otherwise homepage is default */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </MenuWrapper>
  );
};

export default Routing;
